/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to finalize chunk upload.
 * @export
 * @interface ChunksCompleteRequest
 */
export interface ChunksCompleteRequest {
    /**
     * Visit form draft UUID
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    draftId: string;
    /**
     * Form section number
     * @type {number}
     * @memberof ChunksCompleteRequest
     */
    sectionNumber: number;
    /**
     * Media category
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    mediaType: string;
    /**
     * Original filename
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    filename: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    contentType: string;
    /**
     * Total file size in bytes
     * @type {number}
     * @memberof ChunksCompleteRequest
     */
    fileSize: number;
    /**
     * S3 key/path where chunks were uploaded
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    s3Path: string;
    /**
     * Upload session ID returned from init endpoint
     * @type {string}
     * @memberof ChunksCompleteRequest
     */
    uploadId: string;
    /**
     * List of uploaded parts with part number and ETag
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ChunksCompleteRequest
     */
    parts: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the ChunksCompleteRequest interface.
 */
export function instanceOfChunksCompleteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "draftId" in value;
    isInstance = isInstance && "sectionNumber" in value;
    isInstance = isInstance && "mediaType" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "s3Path" in value;
    isInstance = isInstance && "uploadId" in value;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function ChunksCompleteRequestFromJSON(json: any): ChunksCompleteRequest {
    return ChunksCompleteRequestFromJSONTyped(json, false);
}

export function ChunksCompleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunksCompleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'draftId': json['draft_id'],
        'sectionNumber': json['section_number'],
        'mediaType': json['media_type'],
        'filename': json['filename'],
        'contentType': json['content_type'],
        'fileSize': json['file_size'],
        's3Path': json['s3_path'],
        'uploadId': json['upload_id'],
        'parts': json['parts'],
    };
}

export function ChunksCompleteRequestToJSON(value?: ChunksCompleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'draft_id': value.draftId,
        'section_number': value.sectionNumber,
        'media_type': value.mediaType,
        'filename': value.filename,
        'content_type': value.contentType,
        'file_size': value.fileSize,
        's3_path': value.s3Path,
        'upload_id': value.uploadId,
        'parts': value.parts,
    };
}

